import { render, staticRenderFns } from "./ShopHome.vue?vue&type=template&id=a20dca48&scoped=true&"
import script from "./ShopHome.vue?vue&type=script&lang=js&"
export * from "./ShopHome.vue?vue&type=script&lang=js&"
import style0 from "./ShopHome.vue?vue&type=style&index=0&id=a20dca48&scoped=true&lang=css&"
import style1 from "./ShopHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20dca48",
  null
  
)

export default component.exports